const customize = (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
        name: 'Customize product card',
        enabled: true,
        apply: () => ({
            afterRender(element){
                  // Add custom wrapper to every product item
                  let productData = element.getParams()?.props?.product || element.getParams()?.props?.productData || element.getParams()?.props?.data;
                  let productItem = document.querySelectorAll('.boost-sd__product-item[id="' + productData.id + '"]');

                  if(!productItem) return;

                  // Use Ajax to render labels
                  renderAjaxHtml(productData, '.boost-sd__product-item', '.boost-sd__product-image')

                  
            }

        }),

    });
};
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
        customize,
]);
function renderAjaxHtml(productData, itemSelector, targetContainerSeletor) {
    // Use Local Storage
    if (typeof(Storage) !== 'undefined' && typeof config[productData.id] !== 'undefined' && typeof config[productData.id]['custom_labels'] !== 'undefined') {
        console.log('Good')
        let itemEls = document.querySelectorAll(`${itemSelector}[id='${productData.id}']`);
        itemEls.forEach(itemEl => {
          if(!itemEl.querySelector('.boost-sd__product-image .product-label-container')) itemEl.querySelector('.boost-sd__product-image').insertAdjacentHTML('beforeend', config[productData.id]['custom_labels']);
        });

    } else {
        console.log('Almost Good')
        // Use Ajax
        // Set link for ajax
        let productHandleAjax = Shopify.routes.root + 'products/'+ productData.handle + '?view=boost-sd-custom-integration';
        let requestReg = formRequest(productHandleAjax);
        requestReg.then((res_success) => {
            let parse_res_success = JSON.parse(res_success);
            // Set dataAjax local storage config
            setConfig(parse_res_success.id, parse_res_success);
            // Render Ajax Data
            let itemEls = document.querySelectorAll(`${itemSelector}[id='${parse_res_success.id}']`);
            itemEls.forEach(itemEl => {
              if(!itemEl.querySelector('.boost-sd__product-image .product-label-container')) itemEl.querySelector('.boost-sd__product-image').insertAdjacentHTML('beforeend', parse_res_success.custom_labels);
            });
        }).catch((res_error) => {
                console.error(res_error)
        });
      
    }

}
// Add local storage config
if (typeof(Storage) !== 'undefined') {
    var CUSTOM_HTML_STORAGE_KEY = "ajaxCustomLabels";
    var config = JSON.parse(localStorage.getItem(CUSTOM_HTML_STORAGE_KEY)) || {};
    function setConfig(key, value) {
        config[key] = value;
        localStorage.setItem(CUSTOM_HTML_STORAGE_KEY, JSON.stringify(config));
    }
    // Remove local storage config every 8 hours
    var hours = 8; // to clear the localStorage after 1 hour
                   // (if someone want to clear after 24hrs simply change hours=24)
    var now = new Date().getTime();
    var setupTime = localStorage.getItem('ajaxCustomLabelsSetupTime');
    if (setupTime == null) {
        localStorage.setItem('ajaxCustomLabelsSetupTime', now)
    } else {
        if(now-setupTime > hours*60*60*1000) {
            localStorage.removeItem(CUSTOM_HTML_STORAGE_KEY);
            localStorage.setItem('ajaxCustomLabelsSetupTime', now);
        }
    }
}
function formRequest(value) {
  return new Promise((resolve, reject) => {
      var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
      xhr.open("GET", value);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = () => resolve(xhr.responseText);
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
  });
}